import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Doctor } from '../_models/doctor.model';
import {AllMatrixSpecialtiesResponse} from '../_models/PSP/matrix-specialties/all-matrix-specialties-response';

@Injectable({
  providedIn: 'root'
})
export class DoctorsService {
  private static readonly doctorsUrl =  'api/Doctor/';
  private static readonly titlesUrl =  'api/DoctorTitles/GetAll';
  private static readonly typesUrl =  'api/DoctorTypes/GetAll';
  private static readonly languageApi =  '/api/Languages';

  constructor(private http: HttpClient) { }

  getAllDoctorTypes(): Observable<any> {
    return this.http.get(DoctorsService.typesUrl);
  }

  getAllDoctorTitles(): Observable<any> {
    return this.http.get(DoctorsService.titlesUrl);
  }

  getAllDoctors(pramObj): Observable<any> {
    const params = {
      typeId: pramObj.typeId,
      specialityId: pramObj.specialtyId,
      isOnline: pramObj.isOnline,
      isActive: pramObj.isActive,
      currentPage: pramObj.currentPage,
      pageSize: pramObj.pageSize
    };

    return this.http.get(`${DoctorsService.doctorsUrl}GetAllDoctors`, {params});
  }

  addNewDoctor(image, medicalId, payload: Doctor): Observable<any> {
    const formData = new FormData();

    formData.append('imageForm', image, image.name);
    formData.append('fullName', payload.fullName);
    formData.append('arFullName', payload.arFullName);
    formData.append('email', payload.email);
    formData.append('password', payload.password);
    formData.append('titleId', payload.titleId?.toString());
    formData.append('description', payload.description);
    formData.append('arDescription', payload.arDescription);
    formData.append('gender', payload.gender);
    formData.append('birthDate', payload.birthDate.toISOString());
    formData.append('phone', payload.phone);
    formData.append('specialtyId', payload.specialtyId?.toString());
    formData.append('medicalId', payload.medicalId?.toString());
    formData.append('doctorGet', payload.doctorGet?.toString());
    formData.append('consultancyDoctorGet', payload.consultancyDoctorGet?.toString());
    formData.append('slotTime', payload.slotTime?.toString());
    formData.append('cityId', payload.cityId?.toString());
    formData.append('packageLimitNumber', payload.packageLimitNumber?.toString());
    formData.append('packagePeriodInDays', payload.packagePeriodInDays?.toString());
    formData.append('packageDoctorGet', payload.packageDoctorGet?.toString());
    formData.append('packagePatientPay', payload.packagePatientPay?.toString());
    formData.append('userName', payload.userName);
    formData.append('ssn', payload.ssn?.toString());
    formData.append('rank', payload.rank?.toString());
    formData.append('topDoctorRank', payload.topDoctorRank?.toString());
    formData.append('typeId', payload.typeId?.toString());
    payload.acceptPromoCodes&&formData.append('acceptPromoCodes', payload.acceptPromoCodes?.toString());
    formData.append('consultancyDaysWithin', payload.consultancyDaysWithin?.toString());
    formData.append('spokenLanguageIdsList[0]', payload.spokenLanguageIdsList[0]?.toString());
    formData.append('spokenLanguageIdsList[1]', payload.spokenLanguageIdsList[1]?.toString());
    formData.append('medicalIdImage', medicalId, medicalId.name);


    return this.http.post(`${DoctorsService.doctorsUrl}AddDoctor`, formData);
  }

  getDoctorById(id: number): Observable<any> {
    return this.http.get(`${DoctorsService.doctorsUrl}GetDoctorById/${id}`);
  }

  updateDoctor(image,medicalId, payload: Doctor): Observable<any> {
    const formData = new FormData();
    if(image) {
      formData.append('imageForm', image, image.name);
    } else {
      formData.append('imageForm', null);
    }
    formData.append('doctorId', payload.doctorId?.toString());
    formData.append('fullName', payload.fullName);
    formData.append('arFullName', payload.arFullName);
    formData.append('email', payload.email);
    formData.append('password', payload.password);
    formData.append('titleId', payload.titleId?.toString());
    formData.append('description', payload.description);
    formData.append('arDescription', payload.arDescription);
    formData.append('gender', payload.gender);
    payload.birthDate && formData.append('birthDate', payload.birthDate.toUTCString());
    formData.append('phone', payload.phone);
    formData.append('specialtyId', payload.specialtyId?.toString());
    formData.append('medicalId', payload.medicalId?.toString());
    formData.append('doctorGet', payload.doctorGet?.toString());
    formData.append('consultancyDoctorGet', payload.consultancyDoctorGet?.toString());
    formData.append('slotTime', payload.slotTime?.toString());
    payload.cityId && formData.append('cityId', payload.cityId?.toString());
    formData.append('packageLimitNumber', payload.packageLimitNumber?.toString());
    formData.append('packagePeriodInDays', payload.packagePeriodInDays?.toString());
    payload.packageDoctorGet && formData.append('packageDoctorGet', payload.packageDoctorGet?.toString());
    payload.packagePatientPay && formData.append('packagePatientPay', payload.packagePatientPay?.toString());
    formData.append('userName', payload.userName);
    formData.append('ssn', payload.ssn?.toString());
    formData.append('rank', payload.rank?.toString());
    formData.append('topDoctorRank', payload.topDoctorRank?.toString());
    formData.append('typeId', payload.typeId?.toString());
    formData.append('acceptPromoCodes', payload.acceptPromoCodes?.toString());
    formData.append('consultancyDaysWithin', payload.consultancyDaysWithin?.toString());
    payload.spokenLanguageIdsList && formData.append('spokenLanguageIdsList[0]', payload.spokenLanguageIdsList[0]?.toString());
    payload.spokenLanguageIdsList && formData.append('spokenLanguageIdsList[1]', payload.spokenLanguageIdsList[1]?.toString());
    if(medicalId) {
      formData.append('medicalIdImage', medicalId, medicalId.name);
    } else {
      formData.append('medicalIdImage', null);
    }

    return this.http.put(`${DoctorsService.doctorsUrl}UpdateDoctor`, formData);
  }

  getAllFeaturedDoctors(): Observable<any> {
    return this.http.get(`${DoctorsService.doctorsUrl}GetFeaturedDoctors`);
  }

  deleteFeatureDoctor(id): Observable<any> {
    return this.http.put(`${DoctorsService.doctorsUrl}DeleteFeaturedDoctor/${id.id}`, id);

  }

  getAllLanguage(): Observable<any>{
    return this.http.get(`${DoctorsService.languageApi}`);
  }

  getDoctorsByCompanyId(companyId: number, specialtyId: number = null): Observable<any>{
    const searchParams: any = { companyId };

    if (specialtyId !== null) {
      searchParams.specialtyId = specialtyId;
    }

    return this.http.get(`${DoctorsService.doctorsUrl}GetDoctorsByCompanyId`, { params: searchParams });
  }

  getMatrixDoctorsSpecialties(): Observable<any>{
    return this.http.get(`${DoctorsService.doctorsUrl}GetMatrixDoctorsSpecialties`);
  }
}
